/**
 * 来場者機能定数
 * 来場者向け画面で使用する定数を管理します
 */

/** ログイン認証失敗時のエラーメッセージ */
export const VISITOR_LOGIN_INVALID_CREDENTIALS_ERROR_MESSAGE =
  'ユーザ名またはパスワードが正しくありません。';

/** ログイン確認失敗時のエラーメッセージ */
export const VISITOR_LOGIN_CHECK_ERROR_MESSAGE =
  'ログイン確認に失敗しました。通信状況を確認して再度お試しください。';

/** ログイン失敗時のエラーメッセージ */
export const VISITOR_LOGIN_FAILED_ERROR_MESSAGE =
  'ログインに失敗しました。時間をおいて再度お試しください。';

/** ログイン試行回数超過時のエラーメッセージ */
export const VISITOR_LOGIN_RATE_LIMIT_ERROR_MESSAGE =
  'ログイン試行回数が上限に達しました。1分ほど待ってから再度お試しください。';

/** 新規登録のユーザ名重複エラーメッセージ */
export const VISITOR_REGISTER_USERNAME_TAKEN_ERROR_MESSAGE =
  'このユーザ名はすでに使われています。はじめての方は別の名前を入力してください。';

/** 新規登録のユーザ名重複時に、登録済みの人をログインへ案内する文 */
export const VISITOR_REGISTER_USERNAME_TAKEN_LOGIN_GUIDE_MESSAGE =
  'このユーザ名で登録したことがある方は、新しく作らずにログインしてください。新しいアカウントには今までのptが引き継がれません。';

/** 新規登録のユーザ名重複時に出す、ログイン画面へ進むボタンのラベル */
export const VISITOR_REGISTER_GO_TO_LOGIN_LABEL = 'ログイン画面へ進む';

/** 新規登録のパスワード不一致エラーメッセージ */
export const VISITOR_REGISTER_PASSWORD_MISMATCH_ERROR_MESSAGE =
  'パスワード（確認）が一致しません。';

/** 新規登録確認失敗時のエラーメッセージ */
export const VISITOR_REGISTER_CHECK_ERROR_MESSAGE =
  '新規登録の確認に失敗しました。通信状況を確認して再度お試しください。';

/** 新規登録失敗時のエラーメッセージ */
export const VISITOR_REGISTER_FAILED_ERROR_MESSAGE =
  '新規登録に失敗しました。時間をおいて再度お試しください。';

/** 新規登録試行回数超過時のエラーメッセージ */
export const VISITOR_REGISTER_RATE_LIMIT_ERROR_MESSAGE =
  '新規登録試行回数が上限に達しました。1分ほど待ってから再度お試しください。';

/** 利用規約未同意時のエラーメッセージ */
export const VISITOR_REGISTER_TERMS_NOT_ACCEPTED_ERROR_MESSAGE =
  '新規登録には利用規約への同意が必要です。';

/** 利用規約版更新時のエラーメッセージ */
export const VISITOR_REGISTER_TERMS_VERSION_OUTDATED_ERROR_MESSAGE =
  '利用規約が更新されました。最新の内容を確認し、もう一度同意してください。';

/** 利用規約取得失敗時のエラーメッセージ */
export const VISITOR_TERMS_FETCH_ERROR_MESSAGE =
  '利用規約を取得できないため、新規登録できません。通信状況を確認して再度お試しください。';

/**
 * 利用規約の版数表示ラベル
 * DBの`app_terms.version`は同意時の一致検証に使う値（現状は施行日文字列）をそのまま保持するため、
 * 画面表示だけを分かりやすい版数表記に切り離す。現行仕様では規約版の作成・公開に管理画面がなく、
 * migrationで直接追加する運用のため、2件目以降の規約版を追加する際はこのラベルもあわせて更新する。
 */
export const VISITOR_TERMS_VERSION_DISPLAY_LABEL = 'ver3';

/** 新規登録ボタン通常ラベル */
export const REGISTER_BUTTON_LABEL = '登録してはじめる';

/** 新規登録ボタン処理中ラベル */
export const REGISTER_BUTTON_LOADING_LABEL = '登録中...';

/** ポイント最新化失敗時のエラーメッセージ */
export const VISITOR_POINT_REFRESH_FAILED_ERROR_MESSAGE =
  'pt情報の取得に失敗しました。通信状況を確認して再度お試しください。';

/** セッション消失時の案内メッセージ */
export const VISITOR_SESSION_LOST_GUIDANCE_MESSAGE =
  'ログイン状態が消えた場合は、交換窓口または運営スタッフまでお越しください。';

/** QRで開いた画面からログインへ来たときの案内メッセージ（カメラやLINEがアプリと別のブラウザで開いた場合を含む） */
export const VISITOR_LOGIN_RETURN_TO_QR_GUIDANCE_MESSAGE =
  'このブラウザではまだログインしていません。ログインすると、読み取ったQRの続きに進みます。別のブラウザやホーム画面のアプリで使っている方も、同じユーザ名とパスワードでログインできます。';

/** QRで開いた画面から新規登録へ来たときの案内メッセージ */
export const VISITOR_REGISTER_RETURN_TO_QR_GUIDANCE_MESSAGE =
  '登録が終わると、読み取ったQRの続きに進みます。登録したことがある方は、新しく作らずにログインしてください。';

/** オフライン時に送信系操作をブロックした場合の案内メッセージ */
export const VISITOR_OFFLINE_SUBMIT_BLOCKED_MESSAGE =
  'オフラインのため実行できません。電波が回復してからもう一度お試しください。';

/** 景品の必要ptが運営中に変わる場合の交換前案内 */
export const VISITOR_REWARD_POINT_CHANGE_NOTICE =
  '必要ptは運営中に変更される場合があります。交換前に最新の表示をご確認ください。';

/** ptランキングのセッションエラーメッセージ */
export const VISITOR_RANKING_SESSION_ERROR_MESSAGE =
  'ログイン状態を確認できません。再ログインしてください。';

/** ptランキング取得失敗時のエラーメッセージ */
export const VISITOR_RANKING_FAILED_ERROR_MESSAGE =
  'ptランキングの取得に失敗しました。通信状況を確認して再度お試しください。';

/** ptランキングが空の場合のメッセージ */
export const VISITOR_RANKING_EMPTY_MESSAGE = 'ランキング対象の来場者がまだいません。';

/** ptランキングのプライバシー注記 */
export const VISITOR_RANKING_PRIVACY_NOTE_MESSAGE =
  'ランキングにはログイン時のニックネームが表示されます。';

/** 友達グループのセッションエラーメッセージ */
export const VISITOR_GROUP_SESSION_ERROR_MESSAGE =
  'ログイン状態を確認できません。再ログインしてください。';

/** 友達グループ名の入力プレースホルダー */
export const VISITOR_GROUP_NAME_PLACEHOLDER = '例: 勇者一行';

/** 友達グループ招待コードの入力プレースホルダー */
export const VISITOR_GROUP_INVITE_CODE_PLACEHOLDER = '例: AB23CD45';

/** 友達グループ作成ボタン通常ラベル */
export const VISITOR_GROUP_CREATE_BUTTON_LABEL = 'グループを作る';

/** 友達グループ作成ボタン処理中ラベル */
export const VISITOR_GROUP_CREATE_BUTTON_LOADING_LABEL = '作成中...';

/** 友達グループ参加ボタン通常ラベル */
export const VISITOR_GROUP_JOIN_BUTTON_LABEL = 'グループに参加する';

/** 友達グループ参加ボタン処理中ラベル */
export const VISITOR_GROUP_JOIN_BUTTON_LOADING_LABEL = '参加中...';

/** QRスキャン起動ボタンラベル */
export const VISITOR_GROUP_SCAN_BUTTON_LABEL = 'QRを読み取って参加';

/** 友達グループ離脱ボタンラベル */
export const VISITOR_GROUP_LEAVE_BUTTON_LABEL = 'グループを抜ける';

/** グループ内pt送信ボタン通常ラベル */
export const VISITOR_GROUP_TRANSFER_BUTTON_LABEL = 'ptを送る';

/** グループ内pt送信ボタン処理中ラベル */
export const VISITOR_GROUP_TRANSFER_BUTTON_LOADING_LABEL = '送信中...';

/** グループ内pt送信額プレースホルダー */
export const VISITOR_GROUP_TRANSFER_AMOUNT_PLACEHOLDER = '例: 10';

/** 友達グループ離脱確認メッセージ */
export const VISITOR_GROUP_LEAVE_CONFIRM_MESSAGE =
  'グループを抜けますか？\n再度参加するには招待コードが必要です。';

/** 友達グループが空になり削除された場合の案内 */
export const VISITOR_GROUP_DELETED_ON_LEAVE_MESSAGE =
  'あなたが最後のメンバーだったため、グループは解散しました。';

/** 友達グループ取得失敗時のエラーメッセージ */
export const VISITOR_GROUP_FETCH_FAILED_ERROR_MESSAGE =
  'グループ情報の取得に失敗しました。通信状況を確認して再度お試しください。';

/** 現在地更新ボタン通常ラベル */
export const VISITOR_CAMPUS_MAP_LOCATE_BUTTON_LABEL = 'GPSで現在地を取得';

/** 現在地更新ボタン処理中ラベル */
export const VISITOR_CAMPUS_MAP_LOCATE_BUTTON_LOADING_LABEL = '現在地を取得中...';

/** 現在地取得前の案内メッセージ */
export const VISITOR_CAMPUS_MAP_INITIAL_GUIDE_MESSAGE =
  '「GPSで現在地を取得」を押すと、現在地に近い建物名と企画を確認できます。';

/** 位置精度が低い場合の注記しきい値（メートル） */
export const VISITOR_CAMPUS_MAP_LOW_ACCURACY_THRESHOLD_METERS = 100;

/** 位置精度が低い場合の注記メッセージ */
export const VISITOR_CAMPUS_MAP_LOW_ACCURACY_NOTE_MESSAGE =
  '位置精度が低いため、実際の場所とずれている可能性があります。';

/** ログインボタン通常ラベル */
export const LOGIN_BUTTON_LABEL = 'ログイン';

/** ログイン処理中のボタンラベル */
export const LOGIN_BUTTON_LOADING_LABEL = '確認中...';

/** pt取得ボタン通常ラベル */
export const POINT_CLAIM_BUTTON_LABEL = 'ptを取得';

/** pt取得処理中のボタンラベル */
export const POINT_CLAIM_BUTTON_LOADING_LABEL = '取得中...';

/** カメラスキャンセクション見出し */
export const VISITOR_SCAN_CAMERA_SECTION_TITLE = 'カメラで読み取る';

/** カメラ起動ボタンラベル */
export const VISITOR_SCAN_CAMERA_ENABLE_BUTTON_LABEL = 'カメラを起動';

/** カメラ権限不足メッセージ */
export const VISITOR_SCAN_CAMERA_PERMISSION_REQUIRED_MESSAGE =
  'カメラの利用権限が必要です。端末設定から許可してください。';

/** カメラ読み取り成功メッセージ */
export const VISITOR_SCAN_CAMERA_SCANNED_MESSAGE =
  'QRコードを読み込みました。';

/** カメラ読み取り後の案内メッセージ */
export const VISITOR_SCAN_CAMERA_SCANNED_GUIDE_MESSAGE =
  '読み取り後、自動でptを取得します。';

/** カメラ読み取り後のpt取得成功見出し */
export const VISITOR_SCAN_CAMERA_POINT_CLAIM_SUCCESS_TITLE =
  'ポイントゲット！';

/** pt取得入力不正エラーメッセージ */
export const VISITOR_POINT_CLAIM_INVALID_INPUT_ERROR_MESSAGE =
  'pt付与コードを入力してください。';

/** pt取得セッション不正エラーメッセージ */
export const VISITOR_POINT_CLAIM_SESSION_ERROR_MESSAGE =
  'ログイン状態を確認できません。再ログインしてください。';

/** pt取得トークン未検出エラーメッセージ */
export const VISITOR_POINT_CLAIM_TOKEN_NOT_FOUND_ERROR_MESSAGE =
  'pt付与コードが見つかりません。コードを確認してください。';

/** pt取得トークン期限切れエラーメッセージ */
export const VISITOR_POINT_CLAIM_TOKEN_EXPIRED_ERROR_MESSAGE =
  'このpt付与コードの有効期限は切れています。';

/** pt取得トークン利用上限エラーメッセージ */
export const VISITOR_POINT_CLAIM_TOKEN_EXHAUSTED_ERROR_MESSAGE =
  'このpt付与コードは利用上限に達しています。';

/** pt取得トークン無効化エラーメッセージ */
export const VISITOR_POINT_CLAIM_TOKEN_INACTIVE_ERROR_MESSAGE =
  'このpt付与コードは現在利用できません。';

/** pt取得イベント上限エラーメッセージ */
export const VISITOR_POINT_CLAIM_LIMIT_EXCEEDED_ERROR_MESSAGE =
  'この企画はすでにpt取得済みです。同じ企画は1回しかスキャンできません。';

/** pt取得イベント非公開エラーメッセージ */
export const VISITOR_POINT_CLAIM_EVENT_UNAVAILABLE_ERROR_MESSAGE =
  'このイベントは現在pt付与の対象外です。';

/** pt取得一般失敗エラーメッセージ */
export const VISITOR_POINT_CLAIM_FAILED_ERROR_MESSAGE =
  'pt取得に失敗しました。通信状況を確認して、もう一度お試しください。';

/** pt取得の読み取り集中（レート制限超過）エラーメッセージ */
export const VISITOR_POINT_CLAIM_RATE_LIMITED_ERROR_MESSAGE =
  '読み取りが集中しています。少し待ってからもう一度お試しください。';

/** アンケートpt取得済みエラーメッセージ */
export const VISITOR_SURVEY_CLAIM_ALREADY_CLAIMED_ERROR_MESSAGE =
  'このアンケートのptは既に取得済みです。';

/** アンケートコードの試行回数上限エラーメッセージ */
export const VISITOR_SURVEY_CLAIM_RATE_LIMITED_ERROR_MESSAGE =
  'アンケートコードの入力回数が上限に達しました。しばらく待ってからもう一度お試しください。';

/** アンケートpt取得失敗エラーメッセージ */
export const VISITOR_SURVEY_CLAIM_FAILED_ERROR_MESSAGE =
  'アンケートptの取得に失敗しました。通信状況を確認して再度お試しください。';

/**
 * 交換QRを発行し直すときの確認（景品画面・交換QR画面で共通。本文は画面ごとに渡す）
 * 初回の発行は、発行ボタンのすぐ上に交換予定の景品が見えているため確認しない。
 * 発行し直すと発行済みのQRが使えなくなるため、この場合だけ確認する（スタッフが読み取った後の発行はサーバーが断る）。
 * 画面を離れて戻るとQRの表示は消えるが、QR発行済み（取り置き中）の申請が残っていれば発行し直す扱いにする。
 */
export const VISITOR_EXCHANGE_QR_REISSUE_CONFIRM = Object.freeze({
  title: '交換QRを発行し直します',
  confirmLabel: '発行し直す',
  tone: 'danger' as const,
});

/**
 * 表示中の交換QRを発行し直すボタンの文言（交換QR画面の交換QR欄と、景品画面・交換QR画面のカートのシートで共通）
 * QRが読み取れない・画面の表示が古いなど、窓口でQRを出し直したいときに使う。
 */
export const VISITOR_EXCHANGE_QR_REISSUE_BUTTON_LABEL = '交換QRを発行し直す';

/**
 * 注文付きの交換QRの発行後にカートを変えたとき、今のカートの注文で発行し直すボタンの文言（景品画面のカートのシート）
 * 注文の書き換えRPC（exchange_update_order）が無いDBでだけ使う。スタッフが読み取った後はサーバーが発行を断る。
 */
export const VISITOR_EXCHANGE_ORDER_CHANGE_REISSUE_BUTTON_LABEL = '注文を変えてQRを発行し直す';

/**
 * 表示中の交換QRの注文を、発行し直さずに今のカートへ変えるボタンの文言（景品画面のカートのシート、受付停止中）
 * 交換コードは変わらないため、スタッフが読み取った後でも変えられる（スタッフにはもう一度読み取ってもらう）。
 */
export const VISITOR_EXCHANGE_ORDER_UPDATE_BUTTON_LABEL = '同じQRのまま注文を変える';

/** 表示中の交換QRの注文を今のカートへ変えたときの案内 */
export const VISITOR_EXCHANGE_ORDER_UPDATED_MESSAGE =
  '注文を今のカートに変えました。同じ交換QRをそのまま窓口で見せてください。スタッフが読み取った後に変えたときは、もう一度読み取ってもらってください。';

/** 注文付きの交換QRの発行後にカートを空にしたとき、注文を取り下げて注文なしのQRを発行し直すボタンの文言 */
export const VISITOR_EXCHANGE_ORDER_WITHDRAW_REISSUE_BUTTON_LABEL = '注文を取り下げてQRを発行し直す';

/**
 * 受付停止中に、カートも申請中の景品も無いときの景品画面のカートの詳細の発行ボタンの文言（押せない）
 * 在庫もptも確保しない注文で交換するため、交換したい景品をカートに入れてからQRを発行してもらう。
 */
export const VISITOR_EXCHANGE_QR_CART_REQUIRED_BUTTON_LABEL = 'カートに景品を入れてください';

/**
 * カートに入れた後に在庫なしになった景品が残っているときの、カートの詳細の発行ボタンの文言（押せない）
 * 注文は在庫を確保しないため、そのまま発行すると窓口で渡せない景品を注文してしまう（2026/11/03、12番で発生）。
 */
export const VISITOR_EXCHANGE_QR_OUT_OF_STOCK_IN_CART_BUTTON_LABEL = '在庫なしの景品をカートから外してください';

/** 受付停止中に、申請中の景品が無いときの交換QR画面の発行ボタンの文言（押せない。この画面はカートを持たない） */
export const VISITOR_EXCHANGE_QR_ORDER_FROM_REWARDS_BUTTON_LABEL = '景品画面のカートから発行してください';

/** 受付停止中に、申請中の景品が無いときの交換QR画面の交換QR欄の案内 */
export const VISITOR_EXCHANGE_QR_ORDER_FROM_REWARDS_EMPTY_TEXT =
  '申請中の景品はありません。景品画面で交換したい景品をカートに入れ、「注文してQRを発行」を押してください。';

/** 交換QRを発行し直すと発行済みのQRが使えなくなることの案内（確認の本文の末尾に付ける） */
export const VISITOR_EXCHANGE_QR_REISSUE_WARNING =
  '発行済みの交換QRは使えなくなります。';

/** QR発行済み（在庫取り置き済み）の申請を含むまとめて取消の確認（景品画面・交換QR画面で共通） */
export const VISITOR_RESERVED_CANCEL_CONFIRM = Object.freeze({
  title: 'QR発行済みの申請を含みます',
  confirmLabel: 'まとめて取消',
  tone: 'danger' as const,
});

/** 交換QR発行ボタン通常ラベル */
export const EXCHANGE_START_BUTTON_LABEL = '交換QRを発行';

/** 交換QR発行処理中ボタンラベル */
export const EXCHANGE_START_BUTTON_LOADING_LABEL = '発行中...';

/** 交換QRラベル */
export const EXCHANGE_TOKEN_LABEL = '交換用コード';

/** 交換QR有効期限ラベル */
export const EXCHANGE_TOKEN_EXPIRES_AT_LABEL = '有効期限';

/** 交換QRの期限が画面表示中に延びることの案内 */
export const EXCHANGE_QR_AUTO_EXTEND_NOTE = 'この画面を開いている間は、有効期限が自動で延長されます。';

/** 表示中の交換QRで交換が確定したときの案内 */
export const EXCHANGE_QR_REDEEMED_MESSAGE = '交換が完了しました。内容は交換履歴で確認できます。';

/** 表示中の交換QRが期限切れになったときの案内 */
export const EXCHANGE_QR_EXPIRED_MESSAGE =
  '交換QRの有効期限が切れました。交換するときは、もう一度QRを発行してください。';

/** 表示中の交換QRが再発行・取消などで無効になったときの案内 */
export const EXCHANGE_QR_CLOSED_MESSAGE =
  '表示していた交換QRは無効になりました。交換するときは、もう一度QRを発行してください。';

/** 交換開始セッション不正エラーメッセージ */
export const VISITOR_EXCHANGE_START_SESSION_ERROR_MESSAGE =
  'ログイン状態を確認できません。再ログインしてください。';

/** 交換開始入力不正エラーメッセージ */
export const VISITOR_EXCHANGE_START_INVALID_INPUT_ERROR_MESSAGE =
  '来場者情報を確認できません。再ログインしてください。';

/** 交換開始一般失敗エラーメッセージ */
export const VISITOR_EXCHANGE_START_FAILED_ERROR_MESSAGE =
  '交換QRの発行に失敗しました。通信状況を確認して再度お試しください。';

/** 交換履歴空メッセージ */
export const VISITOR_REDEMPTION_HISTORY_EMPTY_MESSAGE =
  '交換履歴はありません。';

/** 交換履歴セッション不正エラーメッセージ */
export const VISITOR_REDEMPTION_HISTORY_SESSION_ERROR_MESSAGE =
  'ログイン状態を確認できません。再ログインしてください。';

/** 交換履歴取得失敗エラーメッセージ */
export const VISITOR_REDEMPTION_HISTORY_FAILED_ERROR_MESSAGE =
  '交換履歴の取得に失敗しました。通信状況を確認して再度お試しください。';

/** お知らせ一覧空メッセージ */
export const VISITOR_NOTICE_LIST_EMPTY_MESSAGE = '公開中のお知らせはありません。';

/** お知らせ一覧取得失敗メッセージ */
export const VISITOR_NOTICE_LIST_FAILED_ERROR_MESSAGE =
  'お知らせの取得に失敗しました。運営担当へご連絡ください。';
